<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapMaterialPullingPlanPlans"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button v-if="createAuth" type="primary" :disabled="!selection.length" @click="createPurchasePlan">创建要货计划</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="批量物料">
            <el-input
                v-model="filter.materialNos"
                type="textarea"
                autosize
                placeholder="请输入物料号"
                clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input
                v-model="filter.materialNo"
                type="textarea"
                autosize
                placeholder="请输入物料号"
                clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="全部" value="-1"/>
              <el-option label="待确认" value="10"/>
              <el-option label="已确认" value="20"/>
              <el-option label="已作废" value="90"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
          <el-form-item label="对接时间">
            <el-date-picker
                v-model="addDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('addDateRange', 'addDateBegin', 'addDateEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-switch
            v-model="scope.row.urgent"
            :disabled="scope.row.status === 20"
            :active-value="true"
            :inactive-value="false"
            active-color="#ff4949"
            inactive-color="#13ce66"
            inactive-text="正常"
            active-text="加急"
            @change="changeUrgent(scope.row.pkId)"/>
      </template>
    </viewTable>
    <create-purchase-plan-dialog ref="createPlan"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import CreatePurchasePlanDialog from "@/views/PurchaseOrderManager/PurchasePlan/CreatePurchasePlanDialog";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name: "PurchasePlanAdd",
    components: {CreatePurchasePlanDialog, viewTable},
    data() {
      return {
        limits: {
          // editAuth: this.$auth(0),
        },
        createAuth: this.$auth(455),
        submitLoading: false,
        createTimeRange:[],
        addDateRange:[],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          buyName: LoginUtil.getName(),
          materialNo:"",
          materialName:"",
          status:"",
          createTimeBegin:"",
          createTimeEnd:"",
          addDateBegin:"",
          addDateEnd:"",
          materialNos:"",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "materialNo",
            align: "center",
            width: 120,
          },
          {
            key: "materialName",
            align: "center",
            width: 300,
            tooltip: true,
          },
          {
            key: "statusName",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "buyName",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "createDate",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "addTime",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "updateTime",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "nextCycle",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "nextGap",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "nextTwoWeekCycle",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "nextTwoWeekGap",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "thisWeekDeliveryDate",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "nextWeekDeliveryDate",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 180,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `sapMaterialPullingPlanPlans/submit/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          });
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      deleteHandle(row) {
        this.$http.delete("basic", "sapMaterialPullingPlanPlans", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      createPurchasePlan() {
        console.log(this.selection);
        const statusArr = this.selection.filter(item => item.status === 20).length;
        if (statusArr) {
          return this.$message.error("请选择未确认的物料！");
        }
        if (!this.selection.length) {
          this.$confirm("请选择物料", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.selection.map(item => {
            item.planType = 1;
          });
          this.$router.push({
            path: "/PurchasePlanPreview",
            query: {
              selection: this.selection,
            },
          });
        }
      },
      changeUrgent(id) {
        this.$http.get("basic", `sapMaterialPullingPlanPlans/changeUrgent/${id}`).then((resp) => {
          if (resp.success) {
            this.$message.success("修改成功");
          }
          this.loadData(1);
        }).catch(() => {
          this.$message.error("修改失败");
        });
      },
    },
  };
</script>
